import React from 'react';

import { AuthenticationPageContext } from './AuthenticationPageContext';

export const AuthenticationPageContextProvider = ({ children }) => (
  <AuthenticationPageContext.Provider value={undefined}>{children}</AuthenticationPageContext.Provider>
);
